import { render, staticRenderFns } from "./AuthTagButton.vue?vue&type=template&id=64dfe71a&scoped=true"
import script from "./AuthTagButton.vue?vue&type=script&lang=js"
export * from "./AuthTagButton.vue?vue&type=script&lang=js"
import style0 from "./AuthTagButton.vue?vue&type=style&index=0&id=64dfe71a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dfe71a",
  null
  
)

export default component.exports